module.exports = __webpack_public_path__ + "components/weather-icon/static/nightlightsnow-797266ddcf7c44e6c4c1dd25e5d1c196.webp";